import React, { FC } from "react";
import { Flex } from "@chakra-ui/react";
import Clients from "../../components/Clients";
import Navbar from "../../components/Navbar";
import Banner from "../../components/Banner";
import AboutSummary from "../About/Summary";
import ServiceCards from "../Services/ServiceCards";
import Footer from "../../components/Footer";
import Testimonials from "../Testimonials";
interface Props {}

const Home: FC<Props> = () => {
  return (
    <>
      <Flex w="100%" h="100%" direction="column">
        <Navbar />
        <Banner />
        <Clients />
      </Flex>
      <AboutSummary />
      <Flex w="100%" h="100%" direction="column" bg="#F0F0F0">
        <ServiceCards />
      </Flex>
      <Testimonials />
      <Footer />
    </>
  );
};

export default Home;
